import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 30905 31207"
    {...props}
  >
    <path
      d="M30255 19134c0 422-343 764-765 764H3258c-422 0-765-342-765-764v-1069c0-422 343-765 765-765h26232c422 0 765 343 765 765v1069zm-11626 1415h1342l-1027 843c-23-315-137-604-315-843zm2411 4035c-562 499-1285 774-2037 774h-7653l-2932 1948-2721-3448-1002-1277 2798-2032h9844c530 0 961 431 961 961 0 220-74 404-163 547l-1 1c-42 67-87 125-130 173-264 296-683 466-1149 466h-3963v650h3963c651 0 1247-249 1634-684 48-52 92-108 133-165l2374-1949h4024l-3980 4035zM8282 28250l-3014 2301c-18 13-41 9-55-6L651 24772l2973-2298c22-18 48-26 75-26 37 0 73 17 97 48l1045 1325 3426 4367 11-9 12 15 175-139 49-32-232 227zM4556 15355c0-6516 5301-11817 11818-11817 6516 0 11818 5301 11818 11817v1295H4556v-1295zM16374 650c617 0 1119 502 1119 1119 0 616-502 1119-1119 1119s-1119-503-1119-1119c0-617 502-1119 1119-1119zm13116 16000h-648v-1295c0-6433-4898-11743-11161-12399 286-314 462-730 462-1187 0-976-794-1769-1769-1769s-1769 793-1769 1769c0 457 176 873 461 1187C8804 3612 3906 8922 3906 15355v1295h-648c-781 0-1415 635-1415 1415v1069c0 780 634 1415 1415 1415h3129l-2100 1524c-264-312-732-366-1060-114L285 24220c-151 109-253 279-278 464-26 186 26 376 143 522l4554 5743c135 169 337 258 541 258 147 0 293-45 417-140l3015-2301c148-113 242-276 266-460 22-174-24-344-124-485l2728-1812h7456c911 0 1788-334 2484-954l4447-4506h3556c780 0 1415-635 1415-1415v-1069c0-780-635-1415-1415-1415z"
      style={{
        fill: "#252422",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
